import HttpService from '../baseHttp'
// 规则列表
export const HttpGetRulesList = (data = {}, config) => HttpService.get('/api/v2/orderrule/findByPage', { params: data })
// 规则详情
export const HttpGetRuleDetail = (data = {}, config) => HttpService.get('/api/v2/orderrule/getRuleDetail', { params: data })
// 保存规则
export const HttpSaveRuleData = (data = {}, config = {}) => HttpService.post("/api/v2/orderrule/saveOne", data, { ...config, headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_BOSS });
// 启用规则
export const HttpActiveRule = (data = {}, config = {}) => HttpService.post("/api/v2/orderrule/enable", data, { ...config })
// 禁用规则
export const HttpDisableRule = (data = {}, config = {}) => HttpService.post("/api/v2/orderrule/disable", data, { ...config })
// 过滤掉禁用状态的仓库
export const HttpFilterDisabledWarehouse = (data = {}) => HttpService.get('/api/v2/organizationWarehouse/findOrgWarehousesByOrgId', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
// // 订单发货规则列表
// export const HttpGetOrderRulesList = (data = {}) => HttpService.get('/api/v2/orderrule/findByPage', { params: data })